import moment from 'moment';
import React from 'react'
import ReactImageFallback from 'react-image-fallback';

// images
import defaultUser from "../../assets/images/default_profile_pic.jpg";


export default function Receiver(props) {
    return (
        <>
            {/* ********* Receiver UI  */}
            <li className="userChat_receiver_msg">
                <ReactImageFallback
                    src={`${process.env.REACT_APP_BASE_URL}/public/storage/${props.chat?.sender_details?.profile_image}`}
                    initialImage={defaultUser}
                    fallbackImage={defaultUser}
                    alt="avatar"
                    className="rounded-circle d-flex align-self-start me-3 shadow-1-strong"
                    width="40"
                />
                <div className="w-100">
                    <h6 className="lh-sm small mb-2">
                        {props?.chat?.sender_details?.first_name != null && props?.chat?.sender_details?.last_name != null ? props?.chat?.sender_details?.first_name + " " + props?.chat?.sender_details?.last_name : props?.chat?.sender_details?.name}
                        <br /><small className='text-muted fw-normal'>{moment(props?.chat.created_at).startOf('hour').fromNow()}</small>
                    </h6>
                    <p className="message_body shadow-sm">{props?.chat?.text}</p>
                </div>
            </li>
        </>
    )
}
